export const parliamentaryQuestionsFilter =
  '["Organismes administratifs et institutions",["Organismes administratifs et institutions","Questions parlementaires"]]';

export const BOFIPFilter =
  '["Organismes administratifs et institutions",["Organismes administratifs et institutions","BOFIP"]]';

export const CASSFilter = '["CASS"]';

export const CEFilter = '["CE"]';

export const placeholderMap: {
  [type: string]: string;
} = {
  arret: 'page/article/components/SearchBarSection.tsx/arret',
  commentary: 'page/article/components/SearchBarSection.tsx/commentary',
  preparatory_work:
    'page/article/components/SearchBarSection.tsx/preparatory_work',
};

const resetMessageMap: {
  [type: string]: string;
} = {
  arret: 'page/components/SearchQuerySection.tsx/arret',
  commentary: 'page/components/SearchQuerySection.tsx/commentary',
  preparatory_work: 'page/components/SearchQuerySection.tsx/preparatory_work',
};

export const getResetMessage = (type: string) => {
  if (!resetMessageMap[type])
    return 'page/components/SearchQuerySection.tsx/11';
  return resetMessageMap[type];
};
